import { EmailBlacklistResource } from 'src/app/models/iblacklist.interface';
import { EmailSubscribeQueryResult, SubscribeForm } from './../../models/isubscribe.interface';
import { HTTP_CONTENT_HEADERS } from 'src/app/shared/data/const.data';
import { catchError, shareReplay, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MessageToastService } from 'src/app/services/common/message-toast.service';
import { environment } from './../../../environments/environment.prod';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class SubscribeService {

  private url = 'subscribe';
  private api = environment.apiUrl;

  constructor(private http: HttpClient, private msg: MessageToastService) { }

  getAll(): Observable<EmailBlacklistResource[]> {
    return this.http.get<EmailBlacklistResource[]>(`${this.api}${this.url}`).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return of([]);
      }),
      shareReplay()
    );
  }

  delete(emails: string[]) {
    return this.http.post(`${this.api}${this.url}/delete`, emails).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return of(null);
      }),
      shareReplay()
    );
  }

  add(emails: string[]) {
    return this.http.post(`${this.api}${this.url}/add`, emails).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return of(null);
      }),
      shareReplay()
    );
  }

  getTable(filter: string): Observable<EmailSubscribeQueryResult> {
    return this.http.get<EmailSubscribeQueryResult>(`${this.api}${this.url}/table/?${filter}`);
  }

  export() {
    const url = `${this.api}${this.url}/export`;

    let hdrs = new HttpHeaders();
    hdrs = hdrs.set('Accept', HTTP_CONTENT_HEADERS.Excel)

    return this.http.get(url, { observe: 'response', headers: hdrs, responseType: 'blob' }).pipe(
      tap((response) => {
        const file = new Blob([response.body ?? ''], { type: HTTP_CONTENT_HEADERS.Excel })
        saveAs(file, 'emails_blacklisted.xlsx');
      })
    );
  }

  subscribe(form: SubscribeForm) {
    return this.http.post(`${this.api}${this.url}`, form);
  }

}
